import { requiredValidator } from "components/Form/Form.utils";
import { IconCollection } from "components/Icon/IconCollection";
import { RelationshipConfig } from "config/config";
import {
    DeleteListAction,
    deleteActionSignature,
} from "containers/Resources/components/CommonActions/CommonActions";
const config: RelationshipConfig = {
    label: "Public key",
    icon: IconCollection.cubeSend,
    resourceName: "user_git_public_key",
    resourceClass: "relationship",
    parentResourceName: "user",
    parentReferenceField: "user_id",
    parentReferenceName: "user_id_user.name",
    layout: [],
    hideCreateNew: true,
    actions: {
        shown: [],
        hidden: [deleteActionSignature],
    },
    listActions: {
        shown: [],
        hidden: [{ key: "delete", action: DeleteListAction }],
    },
    graphql: {
        resource: "user_git_public_key",
        resourceBody: `
            id
            public_key
            user_id
        `,
        resourceBodyListing: `
            id
            public_key
            user_id
        `,
        createVariables: `
            $user_id: String!
            $public_key: String!
        `,
        createQuery: `
            user_id: $user_id
            public_key: $public_key
        `,
        updateVariables: `
            $id: String!,
            $by: String,
            $public_key: String
        `,
        updateQuery: `
            public_key: $public_key
        `,
    },
    form: [
        {
            name: "public_key",
            component: "textarea",
            fieldProps: {
                label: "Public key",
                className: "input--fixedTextareaWidth",
            },
            fieldAttr: {
                required: true,
            },
            validation: requiredValidator,
        },
    ],
};
export default config;
